// Tela 4 — Citação com aspas ilustradas (vetor original do cliente, ver
// SVG/aspas.svg na raiz do projeto "Lorena Magazine") + foto quadrada com
// zoom no rosto. Extraído de entrevista-sergio-gargantini.html (bloco #s3).
// Ver DOCS/04-citacao.md — todas as posições em % foram medidas pixel a
// pixel contra a arte de referência, não são valores arbitrários.
import { escapeHtml, toBrLines } from '../shared/text'
import { LOGO_PRETO_DATA_URI } from '../shared/logo'
import { PLACEHOLDER_IMAGE_DATA_URI } from '../shared/placeholder'
import { cropToImgStyle } from '../shared/crop'
import type { RenderContext, TemplateDefinition } from '../types'

export const CSS = `
  .tpl-citacao{
    padding:0;
    position:relative;
  }
  .tpl-citacao .quote-canvas{
    position:relative;
    flex:1;
  }
  .tpl-citacao .quote-mark-svg{
    position:absolute;
    left:11.99%;
    top:28.05%;
    width:49.5%;
    aspect-ratio:536.32/649.77;
    display:block;
  }
  .tpl-citacao .quote-mark-svg path,
  .tpl-citacao .quote-mark-svg polygon{fill:var(--ink);}
  .tpl-citacao .quote-text{
    position:absolute;
    top:27%;
    right:13.1%;
    max-width:46%;
    font-family:'Big Shoulders',sans-serif;
    font-weight:200;
    font-size:clamp(19px,var(--template-vw-4-4, 4.4vw),28px);
    line-height:1.18;
    text-align:right;
    letter-spacing:.01em;
  }
  .tpl-citacao .quote-photo{
    position:absolute;
    left:62.9%;
    top:44.68%;
    width:24%;
    aspect-ratio:1/1;
    overflow:hidden;
    background:#ddd;
  }
  .tpl-citacao .quote-photo img{display:block;}
  .tpl-citacao .quote-name{
    position:absolute;
    left:62.9%;
    top:65.3%;
    font-family:'Big Shoulders',sans-serif;
    font-weight:300;
    font-size:clamp(11px,var(--template-vw-2-3, 2.3vw),14px);
    letter-spacing:.04em;
  }
  .tpl-citacao .logo{
    position:absolute;
    left:4.07%;
    bottom:3%;
    height:24px;
  }
`

function render(content: Record<string, unknown>, ctx: RenderContext = {}): string {
  const quoteText = toBrLines(String(content.quoteText ?? ''))
  const quoteName = escapeHtml(String(content.quoteName ?? ''))
  const imgStyle = cropToImgStyle(ctx.imageCrop, 1)
  const src = ctx.imageUrl || PLACEHOLDER_IMAGE_DATA_URI

  return `<section class="slide tpl-citacao">
    <div class="quote-canvas">
      <svg class="quote-mark-svg reveal r1" viewBox="0 0 536.32 649.77" aria-hidden="true">
        <path d="M0,428.98v-192.33L120.42,0h109.55l-91.15,217.42h117.07v211.56H0Z"/>
        <polygon points="536.32 220.79 536.32 413.12 416.74 649.77 306.36 649.77 398.35 432.35 280.44 432.35 280.44 220.79 536.32 220.79"/>
      </svg>
      <p class="quote-text reveal r2">${quoteText}</p>
      <div class="quote-photo reveal img-reveal r3"><img src="${src}" alt="" style="${imgStyle}"></div>
      <p class="quote-name reveal r4">${quoteName}</p>
    </div>
    <div class="logo reveal r5"><img src="${LOGO_PRETO_DATA_URI}" alt="Lorena"></div>
  </section>`
}

export const citacaoTemplate: TemplateDefinition = {
  id: 'citacao',
  label: 'Citação',
  tags: ['homem', 'citação', 'foto'],
  css: CSS,
  fieldsSchema: [
    {
      key: 'quoteText',
      label: 'Frase',
      type: 'textarea',
      help: 'Cada linha vira uma quebra manual — mantenha frases curtas (2–3 linhas).',
      placeholder: 'Frase de\nexemplo em\ndestaque',
    },
    { key: 'quoteName', label: 'Nome', type: 'text', placeholder: 'Nome de Exemplo' },
    { key: 'image', label: 'Foto (quadrada, zoom no rosto)', type: 'image', aspectRatio: 1, help: 'Dê zoom até o rosto preencher bem o quadrado.' },
  ],
  render,
  previewContent: {
    quoteText: 'Frase de\nexemplo em\ndestaque',
    quoteName: 'Nome de Exemplo',
  },
  previewCtx: { imageUrl: PLACEHOLDER_IMAGE_DATA_URI },
}
